import { FC, ReactElement, ReactNode } from 'react';

import { useBooleanState } from 'helpers/useBooleanState';

import { BottomSlider } from './BottomSlider';
import { IBottomSliderProps } from './types';

export interface IBottomSliderControlledProps extends Omit<IBottomSliderProps, 'isOpened' | 'onClose' | 'children'> {
  renderController(onClick: VoidFunction): ReactElement | null;
  children: ReactNode | ((props: { onClose: VoidFunction }) => ReactNode);
}

export const BottomSliderControlled: FC<IBottomSliderControlledProps> = ({ children, renderController }) => {
  const [isOpened, setOpened, setClosed] = useBooleanState();

  return (
    <>
      {renderController(setOpened)}
      <BottomSlider isOpened={isOpened} onClose={setClosed}>
        {typeof children === 'function' ? children({ onClose: setClosed }) : children}
      </BottomSlider>
    </>
  );
};
